import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const FourierTransform = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Fourier Transform"
    videos={[
      "https://www.youtube.com/embed/hfIx2P7YUWg",
    ]}
    takeaways={[]}
    questions={[]}
    exampleVideos={[]}
  />
);
}

export default FourierTransform;
